/**
 * About Page Entry Point
 * Static marketing page — no Firebase, map, or reactive state.
 * Loads the global stylesheet and initializes Sentry for parity with the
 * other pages.
 */

import '../styles/main.css'
import { initSentry } from './config/sentry'

initSentry()
